export default class PriceManagementService {
  constructor($http, appConfig) {
    "ngInject";

    this.$http = $http;
    this.appConfig = appConfig;
  }

  getPriceFormula(entityId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/pricelookup/formula/' + entityId);
  }

  updatePrices(entityId, prices, formula) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/pricelookup/update/' + entityId + '?priceFormula=' + encodeURIComponent(formula), prices);
  }
}



// WEBPACK FOOTER //
// ./client/app/components/priceManagement/priceManagement.service.js